var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CodeEditor',{attrs:{"libs":_vm.libs,"label":"Template","label-cols":3},model:{value:(_vm.constraints.custom_data.dataJson.template),callback:function ($$v) {_vm.$set(_vm.constraints.custom_data.dataJson, "template", $$v)},expression:"constraints.custom_data.dataJson.template"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }